class UpcomingProxyBid {
  minBidThreshold;

  bidIncrement;

  bidAmount;

  proxyAmount;

  constructor(minBidThreshold, bidIncrement, bidAmount, proxyAmount) {
    this.minBidThreshold = minBidThreshold;
    this.bidIncrement = bidIncrement;
    this.bidAmount = bidAmount || minBidThreshold;
    this.proxyAmount = proxyAmount || minBidThreshold + bidIncrement;
  }
}

export default UpcomingProxyBid;
